import { render, staticRenderFns } from "./RechargeRecord.vue?vue&type=template&id=120cc016&scoped=true"
import script from "./RechargeRecord.vue?vue&type=script&lang=js"
export * from "./RechargeRecord.vue?vue&type=script&lang=js"
import style0 from "./RechargeRecord.vue?vue&type=style&index=0&id=120cc016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120cc016",
  null
  
)

export default component.exports